import { render, staticRenderFns } from "./UserPaymentMethods.vue?vue&type=template&id=70097194&scoped=true&"
import script from "./UserPaymentMethods.vue?vue&type=script&lang=js&"
export * from "./UserPaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./UserPaymentMethods.vue?vue&type=style&index=0&id=70097194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70097194",
  null
  
)

export default component.exports